import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnInit, ViewChild, } from '@angular/core';
import { LayoutConfigService } from './core/services/layout-config.service';
import { ClassInitService } from './core/services/class-init.service';
import { TranslationService } from './core/services/translation.service';
import * as objectPath from 'object-path';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { PageConfigService } from './core/services/page-config.service';
import { filter } from 'rxjs/operators';
import { SplashScreenService } from './core/services/splash-screen.service';
import { AclService } from './core/services/acl.service';
// language list
import { locale as trLang } from './config/i18n/tr';
import { locale as enLang } from './config/i18n/en';
import { locale as chLang } from './config/i18n/ch';
import { locale as esLang } from './config/i18n/es';
import { locale as jpLang } from './config/i18n/jp';
import { locale as deLang } from './config/i18n/de';
import { locale as frLang } from './config/i18n/fr';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomerService } from './core/services/customer.service';
import { IconsService } from './core/services/layout/icons.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TokenService } from './core/services/token.service';

// LIST KNOWN ISSUES
// [Violation] Added non-passive event listener; https://github.com/angular/angular/issues/8866

export const MY_FORMATS = {
	parse: {
		dateInput: 'DD/MM/YYYY',
	},
	display: {
		dateInput: 'DD/MM/YYYY',
		monthYearLabel: 'MM YYYY',
		dateA11yLabel: 'DD/MM/YYYY',
		monthYearA11yLabel: 'MM YYYY',
	},
}

@Component({
	// tslint:disable-next-line:component-selector
	selector: 'body[m-root]',
	templateUrl: './app.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{
		provide: MAT_DATE_FORMATS,
		useValue: MY_FORMATS
	},],
})
export class AppComponent implements AfterViewInit, OnInit {
	title = 'TURKDEFTER';

	@HostBinding('style') style: any;
	@HostBinding('class') classes: any = '';

	@ViewChild('splashScreen', { read: ElementRef }) splashScreen: ElementRef;
	splashScreenImage: string;

	constructor(
		private layoutConfigService: LayoutConfigService,
		private classInitService: ClassInitService,
		private sanitizer: DomSanitizer,
		private translationService: TranslationService,
		private router: Router,
		private pageConfigService: PageConfigService,
		private splashScreenService: SplashScreenService,
		private aclService: AclService,
		public customerService: CustomerService,
		private iconService: IconsService,
		private tokenService: TokenService,
		private snackBar: MatSnackBar,

	) {
		iconService.setIcon();

		// subscribe to class update event
		this.classInitService.onClassesUpdated$.subscribe(classes => {
			// get body class array, join as string classes and pass to host binding class
			setTimeout(() => this.classes = classes.body.join(' '));
		});

		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {
			this.classInitService.setConfig(model);

			this.style = '';
			if (objectPath.get(model.config, 'self.layout') === 'boxed') {
				const backgroundImage = objectPath.get(model.config, 'self.background');
				if (backgroundImage) {
					this.style = this.sanitizer.bypassSecurityTrustStyle('background-image: url(' + objectPath.get(model.config, 'self.background') + ')');
				}
			}

			// splash screen image
			this.splashScreenImage = objectPath.get(model.config, 'loader.image');
		});

		// register translations
		this.translationService.loadTranslations(trLang);

		// override config by router change from pages config
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe(event => {
				this.layoutConfigService.setModel({ page: objectPath.get(this.pageConfigService.getCurrentPageConfig(), 'config') }, true);
			});
	}

	ngOnInit(): void {
		const url = window.location.href;

		// Token ayarı
		this.tokenService.set(window.location.search);

		// Yeni şifre URL'si kontrolü
		if (url.includes("new-password") && TokenService.url !== "") {
			this.tokenService.setGuid(url.split('?')[1]);
			this.router.navigateByUrl('new-password');
			return;
		}

		// Otomatik giriş için guid kontrolü
		if (url.includes("guid") && TokenService.url !== "") {
			localStorage.clear();
			this.router.navigateByUrl('login/auto-login');
			return;
		}

		// Login olmadan erişim kontrolü
		if (!localStorage.getItem('loggedUser') && !url.includes('/login')) {
			this.router.navigateByUrl('login').then(() => {
				this.snackBar.open('Bu işlem için öncelikle giriş yapmalısınız.', null, {
					duration: 3000,
					horizontalPosition: 'right',
				});
			});
			return;
		}

		// Login sayfasına zaten giriş yapmış kullanıcı gidiyorsa yönlendir
		if (localStorage.getItem('loggedUser') && url.includes('/login')) {
			if (localStorage.getItem('userRole') !== '1') {
				this.router.navigateByUrl('/company/defter/list').then(() => {
					this.snackBar.open('Hâli hazırda giriş yapılmış bir hesap zaten bulunuyor.', null, {
						duration: 3000,
						horizontalPosition: 'right',
					});
				});
			} else {
				this.router.navigateByUrl('').then(() => {
					this.snackBar.open('Hâli hazırda giriş yapılmış bir hesap zaten bulunuyor.', null, {
						duration: 3000,
						horizontalPosition: 'right',
					});
				});
			}
			return;
		}

		// Yetkisiz rollerin belirli sayfalara erişimi engelleniyor
		const userRole = localStorage.getItem('userRole');
		if (userRole !== '1') {
			if (url.endsWith('/settings') || url.endsWith('/announcement') || url.endsWith('/branch/add')) {
				this.router.navigateByUrl('/company/defter/list');
			}
		}
	}


	ngAfterViewInit(): void {
		if (this.splashScreen) {
			this.splashScreenService.init(this.splashScreen.nativeElement);
		}
	}
}
